module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門3_5.50b9179c.png";